import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getBaladiyaRenewData = createAsyncThunk(
  "api/baladiya?renew=1",
  async (token) => {
    try {
      const response = await nodeinstance.get("/baladiya?renew=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const BaladiyaRenewDataSlice = createSlice({
  name: "absher",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBaladiyaRenewData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getBaladiyaRenewData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getBaladiyaRenewData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getBaladiyaRenewData };
export default BaladiyaRenewDataSlice.reducer;
